import { doc, getDoc, DocumentReference } from "firebase/firestore";
import { firestore as db } from "@/utils/firebase";
import { Patterns } from "./types";

/**
 * Get typed document reference for user patterns
 */
const getPatternsRef = (userId: string): DocumentReference<Patterns> =>
  doc(db, "users", userId, "patterns", "main") as DocumentReference<Patterns>;

/**
 * Get user patterns document
 * @param userId - The user ID
 * @returns User patterns or null if document doesn't exist
 */
export const getUserPatterns = async (
  userId: string
): Promise<Patterns | null> => {
  const docSnap = await getDoc(getPatternsRef(userId));
  return docSnap.exists() ? docSnap.data() : null;
};
